import { Box, Typography } from "@mui/material";
import { Card } from "@mui/material";
import Profile from "../../components/templates/AcessControl/Profile";

export function ProfilePage() {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      flex={1}
      py={4}
      px={3}
      bgcolor={"#F9FCFF"}
    >
      <Box display={"flex"}>
        <Typography variant={"h5"}>Perfil</Typography>
      </Box>

      <Card
        sx={{
          display: "flex",
          mt: 4,
          boxShadow: "0px 4px 18px 0px #4B465C1A",
          overflow: "auto",
        }}
      >
        <Profile />
      </Card>
    </Box>
  );
}
